import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-grid',
	templateUrl:'./WaGridPluginCompPage.html',
	styles: [],
	styleUrls:['./WaGridPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaGridPluginCompPage
{
	mdContent_1134 = `\`\`\`java
import com.jwebmp.webawesome.components.WaGrid;
\`\`\``;
	mdContent_1135 = `\`\`\`java
new WaGrid&lt;&gt;()
\`\`\``;
}
